import { apiFetch, ApiError } from "@/lib/api";

const PENDING_INVITATION_KEY = "hojin.pending-invitation-code";

export async function redeemInvitationCode(code: string): Promise<{ ok: true; plan: string }> {
  const response = await apiFetch<{ ok: true; plan: string }>("/api/invite/redeem", {
    method: "POST",
    body: JSON.stringify({ code: code.trim().toUpperCase() }),
  });
  return response;
}

export function invitationErrorMessage(error: unknown): string {
  const status =
    error instanceof ApiError
      ? error.status
      : error && typeof error === "object" && "status" in error && typeof error.status === "number"
        ? error.status
        : 0;
  if (status === 404 || status === 410) return "Code invalide ou expiré.";
  if (status === 409) return "Ce code a atteint son nombre maximal d'utilisations.";
  return "Le code n'a pas pu être vérifié — réessayez.";
}

export function rememberPendingInvitation(code: string): void {
  if (typeof window === "undefined" || !code.trim()) return;
  window.sessionStorage.setItem(PENDING_INVITATION_KEY, code.trim().toUpperCase());
}

export function readPendingInvitation(): string | null {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(PENDING_INVITATION_KEY);
}

export function clearPendingInvitation(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(PENDING_INVITATION_KEY);
}
